// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// const UploadHistory = () => {
//   const [history, setHistory] = useState([]);

//   const fetchHistory = async () => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     const token = user?.token;

//     if (!token) {
//       alert("User not authenticated.");
//       return;
//     }

//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_BASE_URL}stock/upload-history`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       setHistory(res.data || []);
//     } catch (err) {
//       alert("Failed to fetch upload history.");
//       console.error(err);
//     }
//   };

//   useEffect(() => {
//     fetchHistory();
//   }, []);

//   return (
//     <div className="mt-10 p-4 bg-white rounded-md shadow border max-w-7xl mx-auto">
//       <h2 className="text-xl font-semibold mb-4">Upload History (All Data)</h2>

//       {history.length === 0 ? (
//         <p className="text-sm text-gray-500">No uploads available.</p>
//       ) : (
//         <div className="overflow-x-auto">
//           <table className="min-w-full text-sm border border-gray-300">
//             <thead className="bg-gray-100">
//               <tr>
//                 <th className="px-3 py-2 border">#</th>
//                 <th className="px-3 py-2 border">File Name</th>
//                 <th className="px-3 py-2 border">Mime Type</th>
//                 <th className="px-3 py-2 border">Size</th>
//                 <th className="px-3 py-2 border">Download Link</th>
//                 <th className="px-3 py-2 border">User Name</th>
//                 <th className="px-3 py-2 border">Email</th>
//                 <th className="px-3 py-2 border">User Code</th>
//                 <th className="px-3 py-2 border">Role</th>
//                 <th className="px-3 py-2 border">Client ID</th>
//                 <th className="px-3 py-2 border">Is Active</th>
//               </tr>
//             </thead>
//             <tbody>
//               {history.map((item, index) => (
//                 <tr key={item.id} className="hover:bg-gray-50">
//                   <td className="px-3 py-2 border text-center">{index + 1}</td>
//                   <td className="px-3 py-2 border">{item.originalName}</td>
//                   <td className="px-3 py-2 border">{item.mimeType}</td>
//                   <td className="px-3 py-2 border">{item.size}</td>
//                   <td className="px-3 py-2 border">
//                     <a href={item.filePath} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">
//                       Download
//                     </a>
//                   </td>
//                   <td className="px-3 py-2 border">{item.user?.name}</td>
//                   <td className="px-3 py-2 border">{item.user?.email}</td>
//                   <td className="px-3 py-2 border">{item.user?.code}</td>
//                   <td className="px-3 py-2 border capitalize">{item.user?.role}</td>
//                   <td className="px-3 py-2 border">{item.user?.clientId}</td>
//                   <td className="px-3 py-2 border">{item.user?.isActive ? 'Yes' : 'No'}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UploadHistory;
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ITEMS_PER_PAGE = 6;

const UploadHistory = () => {
  const [history, setHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchHistory = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;

    if (!token) {
      alert("User not authenticated.");
      return;
    }

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}stock/upload-history`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setHistory(res.data || []);
    } catch (err) {
      alert("Failed to fetch upload history.");
      console.error(err);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);
  const handleDownload = async (key) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BASE_URL}stock/download-url?key=${encodeURIComponent(key)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const signedUrl = res.data?.url;
    if (signedUrl) {
      window.open(signedUrl, "_blank"); // or use anchor click if you want forced download
    } else {
      alert("Download link not available.");
    }
  } catch (error) {
    console.error("Failed to get download link", error);
    alert("Failed to generate download link.");
  }
};


  const totalPages = Math.ceil(history.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginatedData = history.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <div className="mt-10 p-4 bg-white rounded-md shadow border max-w-7xl mx-auto">
      <h2 className="text-xl font-semibold mb-4">Stock List</h2>

      {history.length === 0 ? (
        <p className="text-sm text-gray-500">No uploads available.</p>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm border border-gray-300">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-3 py-2 border">#</th>
                  <th className="px-3 py-2 border">File Name</th>
                  <th className="px-3 py-2 border">Mime Type</th>
                  <th className="px-3 py-2 border">Size</th>
                  <th className="px-3 py-2 border">Download</th>
                  <th className="px-3 py-2 border">User Name</th>
                  <th className="px-3 py-2 border">Email</th>
                  <th className="px-3 py-2 border">User Code</th>
                  <th className="px-3 py-2 border">Role</th>
                  <th className="px-3 py-2 border">Client ID</th>
                  <th className="px-3 py-2 border">Is Active</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((item, index) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="px-3 py-2 border text-center">
                      {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                    </td>
                    <td className="px-3 py-2 border">{item.originalName}</td>
                    <td className="px-3 py-2 border">{item.mimeType}</td>
                    <td className="px-3 py-2 border">{item.size}</td>
                    {/* <td className="px-3 py-2 border">
                      <a href={item.filePath} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">
                        Download
                      </a>
                    </td> */}

                    <td className="px-3 py-2 border">
  <button
    onClick={() => handleDownload(item.filePath)}
    className="text-blue-600 hover:underline"
  >
    Download
  </button>
</td>

                    <td className="px-3 py-2 border">{item.user?.name}</td>
                    <td className="px-3 py-2 border">{item.user?.email}</td>
                    <td className="px-3 py-2 border">{item.user?.code}</td>
                    <td className="px-3 py-2 border capitalize">{item.user?.role}</td>
                    <td className="px-3 py-2 border">{item.user?.clientId}</td>
                    <td className="px-3 py-2 border">{item.user?.isActive ? 'Yes' : 'No'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-between items-center mt-4 text-sm">
            <button
              onClick={handlePrev}
              disabled={currentPage === 1}
              className="px-4 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className="px-4 py-1 bg-gray-200 rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default UploadHistory;
